import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { isMobileState } from '@/store/atom';

/**
 * 모바일 환경(UA 또는 화면 너비) 여부를 판단하여 Recoil 상태에 반영하는 훅
 * @param threshold 모바일로 간주할 최대 너비 (기본값: 700)
 */
export function useDetectMobile(threshold: number = 700) {
  const [, setIsMobile] = useRecoilState(isMobileState);

  useEffect(() => {
    const detect = () => {
      const isMobileEnv =
        /Mobi|Android/i.test(navigator.userAgent) ||
        window.matchMedia(`(max-width: ${threshold - 1}px)`).matches;
      setIsMobile(isMobileEnv);
    };

    const debounce = (fn: () => void, delay: number) => {
      let timeoutId: number;
      return () => {
        clearTimeout(timeoutId);
        timeoutId = window.setTimeout(fn, delay);
      };
    };

    const debouncedResize = debounce(detect, 150);

    detect(); // mount 시 1회 감지
    window.addEventListener('resize', debouncedResize);
    return () => {
      window.removeEventListener('resize', debouncedResize);
    };
  }, [setIsMobile, threshold]);
}
